import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiEndpoint } from '../api';
import { environment } from '../environments/environment';

import { AccessData, CsrfTokenData, LogoutData, SignInWithCodeData } from './auth.abstraction';
import { HTTP_ERROR_HANDLED } from './http-context-tokens.constant';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService {
  #httpClient = inject(HttpClient);

  getCsrfToken(): Observable<CsrfTokenData> {
    return this.#httpClient.get<CsrfTokenData>(`${environment.apiHost}/${ApiEndpoint.Crsf}`);
  }

  logout(): Observable<LogoutData> {
    return this.#httpClient.post<LogoutData>(`${environment.apiHost}${ApiEndpoint.Logout}`, null);
  }

  refreshToken(refresh: string): Observable<AccessData> {
    return this.#httpClient.post<AccessData>(`${environment.apiHost}/auth/refresh/`, { refresh });
  }

  signIn(token: string): Observable<SignInWithCodeData> {
    return this.#httpClient.post<SignInWithCodeData>(
      `${environment.apiHost}/auth/signin/`,
      { token },
      { context: new HttpContext().set(HTTP_ERROR_HANDLED, true) },
    );
  }
}
